import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SettingsChangeRegisterPage } from 'src/app/modals/settings-change-register/settings-change-register.page';

const routes: Routes = [
  {
    path: '',
    component: SettingsChangeRegisterPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SettingsChangeRegisterPage]
})
export class SettingsChangeRegisterPageModule {}
